module.exports = __webpack_public_path__ + "img/swiper-3.970d937.png";